import StoreConfig from '@/config';
import clsx from 'clsx';
import { ReactNode } from 'react';
import HoverPrefetchLink from '../hover-prefetch-link';
import Price from '../Price';
import { generateLinkHref } from './generate-link-href';
import { generateNextState } from './generate-next-filter-state';

interface Props {
  filterState: FilterState;
  curCategoryUrlKey: string;
  isSearchPage: boolean;
  hideColorsFamily: boolean;
  optionIdMapToRewrite: Record<string, Record<string, string>>;
  colorsFamilyOptions: any[];
  searchParams?: URLSearchParams;
}

const CurrentFilterItems = (props: Props) => {
  const {
    filterState,
    curCategoryUrlKey,
    isSearchPage,
    hideColorsFamily,
    optionIdMapToRewrite,
    colorsFamilyOptions,
    searchParams,
  } = props;

  return filterState.length !== 0 ? (
    <ul className='flex flex-wrap gap-4 pt-4'>
      {filterState.reduce<ReactNode[]>((acc, { attributeCode, options }, i) => {
        if (attributeCode === 'aw_product_stock_condition') return acc;

        for (const option of options) {
          const label =
            attributeCode === 'price'
              ? option.label.split('-').reduce<ReactNode[]>((acc, cur, i, arr) => {
                  const value = parseInt(cur);

                  if (isNaN(value) || !StoreConfig.currency.current_currency_code) return acc;

                  acc.push(
                    <Price
                      value={value}
                      key={i}
                      currencyCode={StoreConfig.currency.current_currency_code}
                      showFractionDigits={false}
                    />,
                  );

                  if (i !== arr.length - 1) {
                    acc.push(<span key={`hyphen-${i}`}>-</span>);
                  }
                  return acc;
                }, [])
              : option.label;
          acc.push(
            <li
              key={option.value}
              className={clsx(
                'px-[5px] py-1',
                'text-[13px] italic',
                'border-1 border-solid border-[#dcdcdc]',
                'flex items-center gap-x-2',
              )}
            >
              <span>{label}</span>
              <HoverPrefetchLink
                href={generateLinkHref({
                  categoryUrlKey: curCategoryUrlKey,
                  filterState: generateNextState({
                    attributeCode,
                    value: option.value,
                    label: option.label,
                    prevStateIndex: i,
                    prevActive: true,
                    filterState,
                    optionIdMapToRewrite,
                    isSearchPage,
                    hideColorsFamily,
                  }),
                  isSearchPage,
                  hideColorsFamily,
                  colorsFamilyOptions,
                  optionIdMapToRewrite,
                  searchParams,
                })}
              >
                <svg
                  xmlns='http://www.w3.org/2000/svg'
                  width='24'
                  height='24'
                  fill='none'
                  stroke='currentColor'
                  strokeLinecap='round'
                  strokeLinejoin='round'
                  strokeWidth='2'
                  className='h-2.5 w-2.5'
                  viewBox='0 0 24 24'
                >
                  <path d='M18 6 6 18M6 6l12 12'></path>
                </svg>
              </HoverPrefetchLink>
            </li>,
          );
        }

        return acc;
      }, [])}
    </ul>
  ) : null;
};

export default CurrentFilterItems;
